<template>
  <q-layout>
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>

export default {
  name: 'App',

  data () {
    return {
      
    }
  }
}
</script>

<style>
</style>
